// extracted by mini-css-extract-plugin
export default {"fullScreen":"Loading_fullScreen__H5Qtd","inline":"Loading_inline__qKZNi","hide":"Loading_hide__qfNLl"};